/*eslint-disable  */
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { OAuth2 } from 'jsforce';

import { getSalesforceToken, parseToken, TokenData, generateCodeChallenge, generateCodeVerifier } from '../utils/Helpers/DupontSalesforceService';
import { DupontLogger } from '../utils';
import { setRequestHeaders } from 'services/api.service';
import { postDataToParent } from 'utils/helper';

interface Props {
  children?: ReactNode;
  onAuthentication?: Function;
  loginUrl?: string;
  clientId: string;
  // clientSecret: string;
  redirectUri: string;
}

const useSalesforceSSO = (initOptions: Props) => {
  const Logger = DupontLogger('useSalesforceSSO');
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [tokenData, setTokenData] = useState<TokenData | undefined>(undefined);
  const [refreshInterval, setRefreshInterval] = useState<number | undefined>();

  async function refreshToken(refresh_token: string) {
    const { clientId } = initOptions;
    const getRefreshTokenParam = {
      client_id: clientId,
      // client_secret: clientSecret,
      refresh_token,
      grant_type: 'refresh_token',
    };
    Logger.log('refreshToken - Token Expiry time in one minutes: ', getRefreshTokenParam);
    //await getSalesforceToken(getRefreshTokenParam);
  }

  const getAuthTokens = async (grant_type: string) => {
    Logger.log('Salesforce - getAuthTokens (PKCE): ', grant_type);

    //extract code from URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    //get stored verifier 

    const code_verifier = sessionStorage.getItem('pkce_code_verifier');
    if (!code_verifier) {
      throw new Error('PKCE verifier missing');
    }

    const data = await getSalesforceToken({
      ...initOptions,
      grant_type,
      code,
      code_verifier,
    });

    if (data) {
      setTokenData(data);
      setRequestHeaders({ authorization: 'Bearer ' + data.authToken });
      setRefreshInterval(data?.refreshInterval);

      //cleanup
      sessionStorage.removeItem('pkce_code_verifier');
    }

    setIsAuthenticating(false);
  };

  useEffect(() => {
    if (refreshInterval && tokenData) {
      setTimeout(() => refreshToken(tokenData?.refreshToken), refreshInterval);
    }
  }, [refreshInterval]);

  const initSSO = async () => {
    try {
      Logger.log('Salesforce');

      if (!window.location.search.includes('code=')) {
        Logger.log('Salesforce - Initiating SSO (PKCE)');

        // Generate PKCE values
        const verifier = generateCodeVerifier();
        const challenge = await generateCodeChallenge(verifier);

        // Store verifier (important)
        sessionStorage.setItem('pkce_code_verifier', verifier);

        // Redirect to Salesforce
        // const oAuth2 = new OAuth2(initOptions);

        const redirectUrl = `${initOptions.loginUrl}/services/oauth2/authorize?` +
          `response_type=code` +
          `&client_id=${initOptions.clientId}` +
          `&redirect_uri=${encodeURIComponent(initOptions.redirectUri)}` +
          `&code_challenge=${challenge}` +
          `&code_challenge_method=S256`;

        window.location.href = redirectUrl;

      } else {
        // Salesforce redirected back with code
        //getAuthTokens('authorization_code');
      }

    } catch (err) {
      Logger.error('initSSO - error: ', err);
      setIsAuthenticating(false);
    }
  };

  const initSSOAuth = () => {
    setIsAuthenticating(true);
    const token = process.env.REACT_APP_AUTH_TOKEN;
    if (token) {
      const data = parseToken(token);
      setTokenData(data);
      setIsAuthenticating(false);
    } else {
      initSSO();
      // if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
      //   initSSO();
      // } else {
      //   const value = { ssoAction: 'LOGIN' };
      //   postDataToParent(value);
      //   sessionStorage.setItem('isUserLoggedin', 'false');
      // }
    }
  };

  // useEffect(() => {
  //   Logger.log('Salesforce useSalesforceSSO - initaiting Authentication ');
  //   initSSOAuth();
  // }, []);

  return { isAuthenticating, tokenData, getAuthTokens, initSSOAuth };
};

export default useSalesforceSSO;
